import {call, put, takeEvery} from "redux-saga/effects"
import { toast } from 'react-toastify';
import store from 'redux/store';
import { GET_SERVICECITY } from "resources/actionTypes"
import { serviceCityApi} from "services/ServiceCityService"

function* fetchCity(action) {
  try {
    const payload = action.payload || {}
    const userServiceCity = yield call(serviceCityApi,payload);

    yield put({ type: GET_SERVICECITY.GET_SERVICECITY_SUCCESS, userServiceCity: userServiceCity });
  } catch (e) {
    yield put({ type: GET_SERVICECITY.GET_SERVICECITY_FAILED, message: e.message });
  }
}

export function* serviceCitySaga() {
  yield takeEvery(GET_SERVICECITY.GET_SERVICECITY_REQUESTED, fetchCity);
}

